import { Loader2, ShieldCheck } from 'lucide-react';

interface Props {
  busy: boolean;
  error: string | null;
  username: string;
  password: string;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: () => void;
}

export function LoginScreen({
  busy,
  error,
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
}: Props): JSX.Element {
  return (
    <div className="mx-auto max-w-[520px] px-6 py-16">
      <div className="card p-8">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-red/10">
            <ShieldCheck className="h-5 w-5 text-brand-red" aria-hidden />
          </span>
          <div>
            <p className="eyebrow">Acesso protegido</p>
            <h1 className="text-2xl font-semibold text-brand-ink">Entrar no Integratio Report</h1>
          </div>
        </div>

        <form
          className="space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            onSubmit();
          }}
        >
          <label className="block text-sm font-medium text-brand-graphite">
            Usuário
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => onUsernameChange(event.target.value)}
              className="mt-1 w-full rounded-xl border border-brand-line bg-white px-3 py-2 text-sm outline-none transition focus:border-brand-red"
              disabled={busy}
              required
            />
          </label>

          <label className="block text-sm font-medium text-brand-graphite">
            Senha mestre
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => onPasswordChange(event.target.value)}
              className="mt-1 w-full rounded-xl border border-brand-line bg-white px-3 py-2 text-sm outline-none transition focus:border-brand-red"
              disabled={busy}
              required
            />
          </label>

          {error && (
            <p role="alert" className="rounded-xl border border-brand-red/30 bg-brand-red/5 px-4 py-3 text-sm text-brand-redDark">
              {error}
            </p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={busy || !username.trim() || !password}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
            {busy ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
